/**
 * This function takes two parameters. The first one is a string with
 * a valid date format.
 * By default, referenceDate is today.
 * If defined, referenceDate will be used as the referenceObj date
 * to check the years against instead of the current date.
 * This referenceDate is useful in testing.
 * @param {string} date
 * @param {string} referenceDate – Optional
 */
function yearsBetweenDates(date, referenceDate) {
  const v = date.replace(/-/g, '/');
  const dateObj = new Date(`${v} 00:00:00`);
  let referenceObj;

  if (referenceDate) {
    const vRef = referenceDate.replace(/-/g, '/');
    referenceObj = new Date(vRef);
  } else {
    referenceObj = new Date();
  }

  let years = Math.abs(dateObj.getFullYear() - referenceObj.getFullYear());
  const refMonth = referenceObj.getMonth();
  const refDay = referenceObj.getDate();
  const dateMonth = dateObj.getMonth();
  const dateDay = dateObj.getDate();

  if (dateObj > referenceObj) {
    // Adjust minus 1 year if date in the future
    // when previous month or same month and previous day
    if (refMonth > dateMonth) {
      years -= 1;
    }
    if (refMonth === dateMonth && refDay > dateDay) {
      years -= 1;
    }
  } else {
    // Adjust minus 1 year if date in the past
    // when posterior month or same month and posterior day
    if (refMonth < dateMonth) {
      years -= 1;
    }
    if (refMonth === dateMonth && refDay < dateDay) {
      years -= 1;
    }
  }

  return Math.abs(years);
}

export default yearsBetweenDates;
